module.exports = __webpack_public_path__ + "static/media/arrow_right_p.2a7fd543.svg";